import axios from "axios";

const AdMedicalApi = axios.create({
  timeout: 300000,
});

var test = "https://webf.cych.org.tw/WebAPI_test/Admin/AdMedicalApi/Api/";
var prod = "https://weba.cych.org.tw/AdMedicalApi/Api/";

var host = "";
// host = "https://localhost:9546/Api/";
host = "https://172.16.59.96/WebAPI/Admin/AdMedicalApi/Api/";
// host = test;
// host = prod;

switch (process.env.VUE_APP_RUN) {
  case "dev":
    AdMedicalApi.defaults.baseURL = host;
    break;

  case "test":
    AdMedicalApi.defaults.baseURL = test;
    break;

  case "prod":
    AdMedicalApi.defaults.baseURL = prod;
    break;
}

export default {
  AdMedicalApi,
};
